<mat-sidenav-container class="application-container">
  <mat-sidenav mode="side" opened>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <p>
            <strong>Applications</strong>
          </p>
          <mat-list>
            <!-- TODO list of applications should be based on broker type -->
            <mat-list-item routerLink="/application/consumer-auto" class="white-link">
              Personal Secured Asset Loan
            </mat-list-item>
            <mat-list-item routerLink="/application/home-loan" class="white-link">
              Home Loan
            </mat-list-item>
            <br/>
          </mat-list>
        </div>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <h2>Welcome the Firstmac Loan Application Wizards!</h2>
          <hr/>
          <p>You are now logged in as <strong>{{user.common_name}}</strong>.</p>
          <p>Click a menu item at the left to begin.</p>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
